import Nao from "../static/images/sectionTalking/2022/Nao.jpg";
import Carina from "../static/images/sectionTalking/2022/Carina.jpg";
import Daniel from "../static/images/sectionTalking/2022/Daniel.jpg";
import Jenny_first from "../static/images/sectionTalking/2022/Jenny_first.jpg";
import Jenny_second from "../static/images/sectionTalking/2022/Jenny_second.jpg";
import Michael from "../static/images/sectionTalking/2022/Michael.jpg";
import Verna from "../static/images/sectionTalking/2022/Verna.jpg";
import Jane from "../static/images/sectionTalking/2022/Jane.jpg";
import Winnie from "../static/images/sectionTalking/2022/Winnie.jpg";
import Oscar from "../static/images/sectionTalking/2022/Oscar.jpg";
import Phoebe from "../static/images/sectionTalking/2022/Phoebe.jpg";
import MaoChun from "../static/images/sectionTalking/2022/MaoChun.jpg";
import Joan from "../static/images/sectionTalking/2022/Joan.jpg";
import Ilin from "../static/images/sectionTalking/2022/Ilin.jpg";
import Jasmine from "../static/images/sectionTalking/2022/Jasmine.jpg";
import Danny from "../static/images/sectionTalking/2022/Danny.jpg";
import Kate from "../static/images/sectionTalking/2022/Kate.jpg";
import Frank from "../static/images/sectionTalking/2022/Frank.jpg";

import Nao2 from "../static/images/sectionTalking/2022/Nao2.png";
import Carina2 from "../static/images/sectionTalking/2022/Carina2.png";
import Daniel2 from "../static/images/sectionTalking/2022/Daniel2.png";
import Jenny_first2 from "../static/images/sectionTalking/2022/Jenny_first2.png";
import Jenny_second2 from "../static/images/sectionTalking/2022/Jenny_second2.png";
import Michael2 from "../static/images/sectionTalking/2022/Michael2.png";
import Verna2 from "../static/images/sectionTalking/2022/Verna2.png";
import Jane2 from "../static/images/sectionTalking/2022/Jane2.png";
import Winnie2 from "../static/images/sectionTalking/2022/Winnie2.png";
import Oscar2 from "../static/images/sectionTalking/2022/Oscar2.png";
import Phoebe2 from "../static/images/sectionTalking/2022/Phoebe2.png";
import MaoChun2 from "../static/images/sectionTalking/2022/MaoChun2.png";
import Joan2 from "../static/images/sectionTalking/2022/Joan2.png";
import Ilin2 from "../static/images/sectionTalking/2022/Ilin2.png";
import Jasmine2 from "../static/images/sectionTalking/2022/Jasmine2.png";
import Danny2 from "../static/images/sectionTalking/2022/Danny2.png";
import Kate2 from "../static/images/sectionTalking/2022/Kate2.png";
import Frank2 from "../static/images/sectionTalking/2022/Frank2.png";

export default [
  {
    name: "KATE",
    position: "Front-End Developer",
    img: Kate2,
    photo: Kate,
    article: `
            <p>​​Hi！我是專案的前端實習生 Kate</p>

            <p>一年前在投履歷的時候應該沒想到有一天會成為寫實習心得的人，真的很感謝當初自己做了這個決定！
            在實習前的我對前端的認識還很不完整，雖然希望自己能夠製作出很棒的網站，但是卻不清楚應該從什麼開始學起，而實習的經驗讓我可以透過各種專案來了解在前端技術上所需具備的能力，也讓我的學習目標更佳清晰！
            </p>

            <p>前端實習生剛加入時，會先從製作基本的待辦清單開始熟悉公司使用的框架和測試工具，熟悉到一定程度後便有機會加入專案團隊，並且看到自己寫的功能實際出現在公開使用的正式網站上。而且在實習期間不論遇到什麼樣的問題都能夠詢問 Mentor，不僅可以學習到解答，還能進一步接收到優化程式碼上的回饋，這是我覺得成為新芽實習生很幸運的一大特點！</p>

            <p>另外新芽的工作氛圍很友善，辦公環境也很舒適，在這裡真的能認識許多朋友，還會有 buddy 的熱心相助！公司提供的各種福利也是絕對不能錯過的！</p>

            <p>若正在看心得的你想加入新芽前端，那就盡所能地展現出對前端的熱情以及學習的潛能，投下履歷吧！</p>
        `,
  },
  {
    name: "WINNIE",
    position: "Front-End Developer",
    img: Winnie2,
    photo: Winnie,
    article: `
            <p>HI～我是前端實習生 Winnie ʕ •ᴥ•ʔ</p>

            <p>跟大家分享我最喜歡新芽的三個地方</p>

            <p>1. 辦公室整片的落地窗，邊做事邊俯瞰松山區和高聳的 101，超級美的 view 讓你每天實習都能有好心情</p>

            <p>2. 扁平的組織結構，和超級活潑又好相處的同事們，有問題時會拿出專業的態度幫忙解決，又同時像朋友般陪你一起打鬧成長</p>

            <p>3. 讓你隨心許願的零食區、免費的飲料和牛奶、outing 出遊、電影之夜、運動大會等等等，新芽有許多好玩又好吃的活動等你來參加！</p>

            <p>再來提到最讚的前端 Team</p>

            <p>1. 進到前端實習，會先確保並教導你具備基本的專案完成能力，例如完整的 Git Flow、React 的使用等，也會讓你開始維護一些案子有初步的熟悉，沒問題的話就接著進開發中的專案，學習如何與 PM、UI、後端、一起合作完成專案！</p>
            
            <p>2. 如果你也對前端有興趣，在新芽，比起學歷更重視你的熱情和那顆學習的心，所以不用擔心自己是不是還沒準備好，展現你的企圖心和上進心（當然也歡迎幽默好笑的人），前端 Team 會是你最好的家！</p>
        `,
  },
  {
    name: "WEDNESDAY",
    position: "Front-End Developer",
    img: Joan2,
    photo: Joan,
    article: `
            <p>Hello, 我是新芽 SurveyCake Front-End Developer Intern 的實習生 Wednesday 陳佳雯。</p>
            <p>在公司負責蛋糕新官網的開發、維護蛋糕的 End-to-End Testing，並偶爾參與蛋糕前端的開發。</p>

            <p>之前為了一個募資計畫使用 SurveyCake 專業版設計問卷，當時被蛋糕的多樣化功能吸引，並好奇這樣的產品是如何被開發出來的。進到新芽之後很幸運地加入蛋糕團隊，在這邊收穫最大的就是學習到蛋糕完善的 Git Flow，這是在一般小型專案或是學校專案沒有機會體驗到的。</p>

            <p>這邊的組織結構非常扁平，蛋糕的實習生也會加入 scrum team，參加例會、開發會議、PM 的產品分享會議等等，了解產品最新的脈動。如果有任何問題也可以直接跟厲害的正職同事們討論，從實際的工作中增進自己的前端技術。</p>

            <p>最後，新芽身為一個老創卻仍擁有新創的氛圍，公司有吃不完的零食、明亮溫馨的辦公室、前端歡樂的工作氛圍，最重要的是有非常照顧實習生的 Mentor，以及來自不同校系的實習生。如果想要體驗前端工作、寫自動化測試、結交許多好朋友，歡迎投履歷試試看！</p>
        `,
  },
  {
    name: "OSCAR",
    position: "Back-End Developer",
    img: Oscar2,
    photo: Oscar,
    article: `
              <p>Hi, 我是 Back-End Intern Oscar.</p>

              <p>從面試時就非常喜歡新芽，前輩們沒有因為非相關科系就先入為主，而是認真聽著我的 side project 和社團經歷。事實也證明，只要對後端開發具有高度熱情，喜歡探究並解決問題，新芽真的會提供發揮的機會！</p>

              <p>至於在新芽參與開發最美好的事情，就是這裡有完善的開發文化，包括專案規格確立、前後端分離與協作、獨立的 DevOps 團隊、知識管理系統、內部框架與開發工具等，讓開發流程能夠順暢且同步。實習初期對於開發環境還不熟悉時，有 Mentor / Buddy 和一群堅強的後端大神後盾們協助，扁平的組織文化讓一切可以更無壓力與開放的去討論。</p>

              <p>此外，新芽讓我感到最酷的是自己沒有被前輩當成打雜的實習生，比如只能寫寫測試和文件，或是修點小 bug，反而是給予我信任，讓我實際去跟其他部門討論合作方案，開發公司高潛力的新專案，從頭到尾參與專案開發的流程。回過頭來看，自己已經在這過程中成長了好多，彷彿就是真正的後端工程師一樣，以前甚至從來沒有想過自己寫出來的程式可以真的被企業使用，我現在都會跟朋友說自己是估值多少錢的男人（^_^？）</p>

              <p>除了工作內容以外，我也很注重自己的生活品質，而新芽的工作環境就如同職缺敘述所說的那般美好。由於是採取彈性工時的作法，不會產生被工作綁住無法脫身的厭世感，尤其公司也不鼓勵加班，每週的後端例會讓主管可以了解每個人的工作量並予以調整。另外，如果你跟我一樣是個懶人，可以 WFH 來省去通勤成本，偶爾再進漂亮的開放式辦公空間感受咖啡廳的氛圍。只能說第一份實習在新芽真的很幸運！</p>

          `,
  },
  {
    name: "JASMINE",
    position: "Back-End Developer",
    img: Jasmine2,
    photo: Jasmine,
    article: `
            <p>Hello ! 我是 Back-End Intern Jasmine</p>

            <p>當初之所以選擇投遞新芽，純粹是在做公司背景研究時，被老闆過去在 Medium 中紀錄下的創業初衷：「我們想要找到可以有一輩子熱情的工作，但因為找到這樣的工作很難，所以我們決定創造一個」所深深吸引</p>
            
            <p>在加入新芽前的我曾經迷惘一陣子，懷疑自己是否真的喜歡自己心目中嚮往從事的工作，而新芽給我的感覺就像是一艘在茫茫大海中快速前進，卻又能完美保持平衡的小船，你能在這裡經歷到變動快速的工作體驗，卻不會讓你獨自一人承受大風大浪，而正是因為這份安穩前進的力量，讓我能有更多機會去盡情嘗試與釐清這份迷惘
            並且我也體認到，一個工程師不僅要懂得怎麼寫出高品質的 code ，在下手前更是要清楚明白你在處理的是什麼問題？是為了什麼而處理？是否會有更簡單的處理方式？能否協助篩選出最適合當下環境的 solution？</p>
            
            <p>身為新芽後端 Intern，你可以<br>- 學習如何與 Front-End、PM 等不同部門一同合作解決問題<br>- 練習如何更為簡潔俐落的落實維護性高的 Code Structure<br>- 培養身為 Web Back-End 的 Basic Mindset<br>- 實際參與專案開發，並能學習具一定規模程度專案的架構與流程設計<br>- 跟許多大神前輩互相交流技術</p>
            
            <p>不僅能在技術層面獲得成長，更能享受公司豐富的福利、認識各種跨域人才、體驗活潑輕快的公司文化，若你現在對未來感到迷惘，更是不想被傳統思維綁架限制自己的視野的話，快快來一起成為 Sprouter 吧！</p>
            `,
  },
  {
    name: "MICHAEL",
    position: "iOS Developer",
    img: Michael2,
    photo: Michael,
    article: `
            <p>安安~ 大家好 我是 iOS Intern - Michael 柏帆</p>
            <p>不知不覺已經待在新芽半年多過去了，在這邊的日子可以說是過得非常充實，儘管一開始的自己是個只有極度非常超級基礎到不行的技能，但隨著時間推移，在專案裡所遇到的問題其實都能夠從中慢慢學習到很多不同從未學習過的新技術、套件、框架的使用，還有很多開發過程是在學校裡所體驗不到的，所以我相信不管是初出茅廬或是有不錯基底的你各位，其實都能夠在新芽裡能有所收穫，同時也期望有著樂於學習的心，遇到瓶頸時可以多多請教身邊的 mentor，甚至是前、後端的開發者，試著詢問不同人對於問題的意見或看法，我想會對將來面對處理事情的時候而有所幫助！</p>
            <p>再來提到公司的文化的話，我可能會以大學氛圍來形容，因為是開放辦公空間的關係，其實會很輕易地接觸到各個不同部門的同事，而且大家真的都非常和藹可親好相處，加上年齡差距不大的原因，完全不用太擔心會有那種老古板，非常傳統的上下階級關係，只要願意與人交流的話，絕對是可以在公司交到很不錯的同事朋友，說不定在未來職場的道路上會有互相幫助到的機會。</p>
            <p>最後，如果你對於 iOS 開發也感興趣的話，來新芽實習會是你的第一個好選擇唷！</p>`,
  },
  {
    name: "Jenny Chiang",
    position: "Android Developer",
    img: Jenny_first2,
    photo: Jenny_first,
    article: `
            <p>大家好，我是 APP Team 的 Android 實習生 Jenny</p>
            <p>在新芽實習能夠實際參與開發中的專案，不論程式規模、邏輯或是功能流程都比過去在學校接觸到的項目來的複雜；也因為專案的規模不小更能理解到 APP 開發中基本架構和版本控制的重要性。</p>
            <p>開發過程難免會遇到挫折，值得慶幸的是 APP Team 裡的每個人都很願意給予幫助和回饋。能夠自己獨立完成 issue 會獲得很大的成就感，但遇到解不開的問題時也不用害怕請教團隊裡的其他人。</p> 
            <p>實習過程一邊吸收一邊產出，感受到過去從未有過的體驗和成長，如果你對應用程式開發有興趣，也想體驗自由彈性的工作氛圍，新芽會是一個好選擇~</p>
          `,
  },
  {
    name: "JANE",
    position: "Project Management",
    img: Jane2,
    photo: Jane,
    article: `
            <p>嗨大家好，我是 Project Management Intern - Jane。</p>
            <p>回想當初投遞履歷純粹是對於專案管理這個工作感到好奇，面試的時候也完全沒想過自己可以加入新芽實習，收到錄取通知信的當下簡直比看到學測成績還緊張（？）但還是很慶幸自己可以在求學階段透過實習認識不同的行業，進而了解到自己適合什麼樣的工作。</p>
            <p>我在實習期間接觸到很多不同性質的專案，也參與了幾個專案從開發到上架的完整流程；在第一線觀摩正職 PM 與客戶及開發者互動、討論開發需求的過程，雖然很繁瑣、很複雜，但也從實務面學習到很多知識，除了對於網路產業、軟體開發都有一定的認識外，也深深了解到軟實力以及時間管理之於 PM 的重要性，這些都是課本裡面沒辦法接觸到的 (ง •̀_•́)ง</p>
            <p>而我主要的工作內容包括：進行開發產品的測試、一同參與負責專案的客戶/內部例會、整理會議記錄、撰寫操作手冊，此外，每個月也會與其他實習生一起準備不同主題的 reference 與部門同事分享 ٩(˙︶˙)۶ 在這邊想跟大家說的是，雖然一開始不熟悉工作內容時會覺得 loading 重、常常搞不清楚狀況、也常犯錯，但我很喜歡的是新芽總給予實習生很大的發揮空間、包容度也很高，PM 們也是一步一步的指導我們儘快上手專案，並不會因為是實習生所以就指派我們太過打雜的工作。</p>
            <p>雖然因為疫情的關係真的少了很多與同事們實際互動認識的機會（與同事之間的關係就像網友一樣）、沒有體會到像以前一樣熱鬧歡樂的辦公室氣氛、也少了很多疫情前可以參與的活動，或多或少還是會讓我覺得可惜 ಥ_ಥ 可是也必須說正是因為這樣採取彈性遠端的工作模式，反而給了我很大的自由度，讓我可以更好的安排自己的時間跟自由穿梭在不同的環境中工作 (´˘\`)♡</p>
            <p>最後要跟大家說，過去幾屆實習生分享的扁平化的組織結構、自由開放的工作氛圍、辦公室跟咖啡廳一樣漂亮、DJ 放的音樂很好聽、零食區總是有吃不完的零食（而且還可以開放許願）、常常有同事投餵來自不同國家的食物、尾牙、住高級飯店的 outing 等等，這些都是真的，新芽對實習生的用心絕對可以真實地體會到</p>
            <p>如果對於專案管理、網路軟體業或甚至對於新芽這間公司充滿好奇，不妨試試投遞履歷吧，或許也可以成為新芽大家庭的一份子</p>
    `,
  },
  {
    name: "VERNA",
    position: "Account Management",
    img: Verna2,
    photo: Verna,
    article: `
            <p>嗨，我是 Account Management Intern - Verna 卓宜蓁。</p>
            <p>我帶著想來這裡認識不同產業的期待，過了一段很充實也很幸福的實習生活。 想起當初面試時充滿挫折，但沒想到作為科技小白卻意外有了加入新芽的機會。雖然充滿迷茫地走出舒適圈，但踏進網路科技後的世界每一天都沉浸在新鮮感中。</p>
            
            <p>AM 主要的工作為接洽專案客戶，釐清網站或 APP 建置的需求，透過基礎的使用者研究，找到客戶、使用者的痛點，並提供改善體驗上的建議或新功能發想；有許多提案與需求討論的業務拜訪，像是在大觀園中一輪遊、見到各式各樣背景人；還有 nice 這個詞涵蓋的所有特質的 mentor 一起成長和互相 inspire，擔任 AM Intern 的每一個接觸點都深深感覺自己也能扮演一個有影響力的分享者。如果你平常喜歡看 APP 、找網站，操作上很麻煩時會氣噗噗，在意使用流程與用戶感受；會做簡報也算會說話還有點版面整齊介面漂亮的強迫症（？） AM 歡迎光臨你貢獻所有對介面和操作體驗的想像！</p>
            
            <p>在這些日子有很多印象深刻的時候，一無所知地打著空耳會議記錄的菜鳥暑假、第一次見客戶發名片、被簡報淹沒提案追著跑的地獄週。這些焦慮和快樂夾雜的工作回憶，直到現在仍是不斷支持著我更紮實地認識網路科技世界的經驗值。常說當學生就是犯錯最好的時候，但是當自己開始真正的站在第一線接觸客戶、提案要接受客戶的批判與喜惡時，也會經歷無數自我懷疑和接受社會衝擊，但也同時建立更加全面和具建設性的點子資料庫，也蛻變成更堅強也更專業的需求引路見習者。得到的比預期多太多太多，我的第一份實習能在新芽度過實在是太幸運了。</p>
            
            <p>如果你想做的事情都很不一樣、對網站、APP 有很多想像，那就來新芽實現吧！（也可以來辦公室快樂吃零食、交到很棒的朋友：））</p>
          `,
  },
  {
    name: "ILIN",
    position: "Marketing",
    img: Ilin2,
    photo: Ilin,
    article: `
            <p>哈囉~我是新芽 SurveyCake Marketing Intern－Ilin 陳羿霖。</p>
            <p>想當初大三暑假在找實習的時候投了三間，最想要進的就是新芽！會選擇投 MKT 實習是因為我以往只有在社團與學生組織有行銷設計的經驗，在系上學了行銷，卻不知道在實務界的行銷是長甚麼樣子，加上原本就是 SurveyCake 的愛用者，就決定投下去啦！</p>
            <p>MKT 的主要任務就是傳遞與提升品牌價值，是各部門的交會點！在 MKT 部門裡，我的工作主要有部落格撰寫與優化、粉專圖文製作、官網彈窗製作、每個月的各項數據統計整理，還有其他任務支援。來說說一些印象深刻的事情，像是：從以前逛 Meet Taipei 的人變成在攤位上顧展與介紹的人、在例會上提出的想法被納入 OKR 並實際參與其中、第一次用各種數據監測工具（GA、Amplitude...）並設法找出 insight、訪談學生族群的使用經驗得出有趣的洞察等。</p>
            <p>在實習上的實務經驗讓我在學校修相關的課時有更好的發揮與見解，也讓我確定日後要往行銷的職涯道路上前行。在 MKT team，任何想法都可以不用擔心的提出來與夥伴們激盪，在群組也能常常收穫到行銷趨勢與最新資訊分享，姊姊們都很 nice，整個部門關係很緊密╰(*°▽°*)╯</p>
            <p>超級美的辦公室（我都喜歡坐在靠窗的位置，陽光灑進來有夠美）、吃不完的零食櫃、超高級的 Outing、活潑友善的環境等等這些前面相信你們都看過介紹了，我最喜歡的是公司的 remote 制度，讓我可以一邊兼顧學校的修課，有超級彈性的排班，可以自由選擇要不要 WFH 沒有限制！（我是個去學校要一小時、來公司要四十多分鐘的通勤仔）雖然因為疫情的關係少了比較多認識其他部門夥伴的機會，每次進辦都有一種見網友的感覺 XD 但是不用通勤真的方便很多，也省下不少時間～</p>
            <p>很喜歡 Alex 在我們入職第一天分享的一句話「你必須非常努力，才值得擁有那些幸運，但一點也不僥倖」。很幸運第一份實習在新芽，在賣蛋糕互助會跟夥伴們一起成長茁壯。看完這麼多實習生的分享，有沒有一點心動了呢？歡迎勇敢投遞你的履歷，成為新芽的一份子，把蛋糕賣到全世界吧！</p>
          `,
  },
  {
    name: "NAO",
    position: "Marketing",
    img: Nao2,
    photo: Nao,
    article: `
            <p>哈囉～我是 SurveyCake Marketing Intern 的 中山尚彥 Nao</p>
            <p>我很榮幸能在新芽成為第一個日本之芽，擔任 SurveyCake 的日本市場發展和開發。</p>
            <p>當初是想找研究所畢業後可以連結日本和台灣的職位，投了日本和台灣 30 幾家公司機關之後，看到新芽在招開拓日本市場的實習生，感覺就像找到我的 Perfect Match！！</p>
            <p>我第一次接觸 SurveyCake 是我在日本讀大學的時候，看到台灣人的朋友在使用這個漂亮又實用的雲端表單給我很深刻的印象。但可惜當時沒有日文版，我就沒辦法使用了 (ﾉﾟдﾟ)ﾉ</p>
            <p>幾年後，我很高興成為新推出的 SurveyCake 日文語系的幕後推手，站在 SurveyCake 跨海外市場的第一線。</p>
            <p>MKT 的主要任務在推廣 SurveyCake 和提升品牌價值，更是新芽各部門和市場的交會點，有效的溝通很重要！我在 MKT 部門，甚至在整個新芽最重要的任務是推動和開發日本市場，而且是幾乎從零開始的。首先準備日文語系的 SurveyCake 產品，並同時建立發展日本市場的 Roadmap。過程中跟各部門的溝通和學習更加重要。工作內容包括整個 SurveyCake 日文語系的準備和翻譯、新芽的日文版官網翻譯和優化、建構日本市場開拓戰略、申請日本政府補助、日本市場的競品分析、日文行銷廣告製作和投廣、與日本合作夥伴的溝通和開會、製作日文支援中心、支援日本客戶、與日本企業合作提案等 ; 這同時也涵蓋到 PM、BD、CS等 的領域，跟各部門的溝通真的很重要！不只是 SurveyCake 部門，我也很榮幸參與支援 BackStage 部門接洽日本客戶。</p>
            <p>在這些工作中，我在新芽成為台灣和日本的橋樑，一同成長！</p>
            <p>疑？這不就是我當初想找的 Dream Job？？　٩(๑˃̵ᴗ˂̵๑)۶</p>
            <p>身為新芽唯一的日本人，我很高興在新芽有機會可以大大發揮，跟可愛又強的同事們一起從「零到一」的狀態開拓日本市場，成為海外拓展大進擊的第一步 (ง •̀_•́)ง</p>
            <p>在新芽真的很像在大學一樣，辦公室裡面每天都是笑聲不停，沒有什麼像日本的上下關係，辦公室和工作環境我就不用說了！ 超級彈性的排班和 WFH 制度讓我可以在實習中同時兼作完成我的碩士論文，與學業和生活的平衡是非常彈性的！</p>
            <p>還在猶豫什麼？一起成為新芽的成長的一部分，盡所能的展現出你的熱情和潛在能力吧！</p>  
          `,
  },
  {
    name: "JENNY WU",
    position: "UI/UX Design",
    img: Jenny_second2,
    photo: Jenny_second,
    article: `
            <p>Hi 我是 UI / UX  Design Intern Jenny</p>
            <p>不知不覺也來新芽半年了，想當初投履歷的時候因爲沒有相關經驗，很擔心自己會被刷掉，但很慶幸最後有機會加入新芽這個大家庭，遇到很多厲害的同事，也接觸到很多不同領域的專案，讓我成長不少！</p>
            <p>我主要是負責支援各個設計專案，透過實作、一起參與客戶提案、與不同部門一同討論與執行，學習許多專案設計中重要的知識和實作技巧，同時也累積跨部門協作經驗。團隊的工作氛圍也是我很喜歡新芽的原因，如果遇到任何問題都可以隨時詢問身邊的同事，大家都很樂意一起討論、從旁給予協助。另外，我們部門平常也經常會在 slack 或在會議中分享一些設計趨勢、設計工具和文章，互相交流學習。部門也會有不定期的設計 workshop， 可以一同討論學習，學習資源真的很豐富：）</p>
            <p>最後還是要讚嘆一下新芽的辦公環境，不但有吃不完的零食又有超級美的辦公區和好聽的音樂，整個工作氛圍就很輕鬆很愉悅，很像在咖啡廳工作。假如你家離公司很遠或是不方便進公司也可以選擇 WFH，可以更活用自己的時間，完全不用擔心。 如果你對 UI/UX 有興趣或是想要了解專案設計、累積作品集，很推薦你加入新芽！相信你會學到很多，也能快速拓展自己的視野！</p>
          `,
  },
  {
    name: "DANIEL",
    position: "Business Development",
    img: Daniel2,
    photo: Daniel,
    article: `
            <p>Hello~ 我是 Business Development Intern - Daniel 丹牛</p>
            <p>沒想到一下子就在新芽實習快滿一年了，回想當初在四處搜尋實習機會時，冥冥之中就被這個酷酷的 Intern 招募 landing page 給深深吸引，而也在了解新芽是一間多麼「酷」、年輕且有活力的網路新創公司後，就下定決心且毫不猶豫地投了人生的第一份履歷，期許自己能夠在這一年和新芽一起成長，而最後也算是非常幸運的拿到了 offer，在新芽展開了這段對我來說收穫非常多且充滿各種驚奇與回憶的實習體驗 : )</p>
            <p>25sprout BD 的角色，簡單來說就好比是一座橋梁，要試著對外拓展、開發更多的夥伴合作及產品線，同時也要對內進行資源的盤點及跨部門間的溝通、協作。而身為 BD Intern，主要的任務是協助篩選、分析潛在的合作夥伴、與夥伴洽談商業、技術層面等的合作機會，此外，偶爾也會有些特殊的專案，如夥伴成效的 Dashboard、persona、用戶數據分析...等各種充滿挑戰的嘗試與學習，所以在這裡實習肯定會有很多不論在軟、硬實力上的提升及經驗累積。</p>
            <p>而在新芽實習的這 9 個多月來的過程中，學到非常多在軟體產業、商業數據方面等的知識外，也因為新芽給了實習生很大的發揮空間，因此更是收穫了很多非常特別且有趣的經驗，像是有機會代表公司去開發不同的軟體科技公司、洽談、規劃想提案合作的夥伴、和不同公司的老闆們開會，提出不同想法一起討論、和主管們提出想嘗試的專案，並實際著手執行、甚至和 Alex 打球!? ... 等，以上種種在我進新芽前從未想過的新奇體驗，都讓我覺得自己真的非常非常幸運第一份實習可以在這麼讚的環境，也真的非常感謝新芽給實習生這麼大的發揮空間，讓我有機會能跟一群很棒的夥伴一起學習、成長 !</p>
            <p>最後，當然不免俗的要提到新芽的環境及福利真的很讚，超美的辦公室、吃不完的零食櫃、超酷的 Outing、尾牙、按摩....還有很多很多 ! 所以還在猶豫的你，勇敢跨出舒適圈投下你的履歷，一起成為新芽的一份子吧! 相信這裡的一切不會讓你失望的 oh yaeee : )</p>
          `,
  },
  {
    name: "MAO CHUN",
    position: "Customer Success",
    img: MaoChun2,
    photo: MaoChun,
    article: `
            <p>Hello，我是 Customer Success Intern - MaoChun～</p>
            <p>在新芽裡主要負責協助 SurveyCake 用戶解決使用問題、蒐集 SurveyCake 用戶使用資訊、幫助 SurveyCake 成為對用戶更友善的服務！</p>
            <p>最初會接觸到這份實習機會，其實也純然因為在學校裡時不時會收到各種使用 SurveyCake 製作的問卷，並被問卷裡精美、細緻又人性化的設計所吸引，因此有了想要進入新芽一探究竟的念頭，而 Customer Success 這份和傳統客服相近卻又不同的工作，也鼓動我的好奇心並決定投身其中。</p>
            <p>雖然動機很宏大，但實際進入新芽時我內心也有著不少的惶恐。我不論在學經歷或是過往經驗，都和 SaaS 產業、客戶服務毫無相關，不免對於工作上能否適應有些擔憂，然而無論從公司、主管、Mentor到同事，都對於實習生抱持著開放態度，願意一步步且有系統地指引實習生適應公司文化以及工作內容，並同等重視實習生的想法與建議，使我能夠安心表達自我並順利融入新芽。</p>
            <p>或許很多人會擔憂在 CS 相關領域中實習，會不會都在處理例行性文書工作，但在 SurveyCake CS 團隊中，主管以及同事都會積極詢問實習生希望在實習結束前能夠得到收穫有什麼，並盡可能地尋找甚至創造相關機會。例如在實習期間，我也參與了使用者習慣分析、建構客服機器人系統等團隊專案。</p>
            <p>在過往台灣受到疫情影響的一年，少了很多能夠享受新芽漂亮、舒適辦公座位的機會，但能夠採取彈性遠距的上班方式，對於我來說也受益良多。平時能夠在家中工作，無論是工作步調的調適或是時間上的安排都增加了許多自由度，進辦公室和同事見面時也能感受和網友見面的驚喜感，也算是另一種意想不到的收穫吧（？</p>
            <p>總而言之，在這裡你不會被學經歷的框架限制，能夠盡可能發揮自己的能力，學習到各種工作技能與經驗。無論你是對於公司本身、 SaaS 產業或是 CS 相關工作感興趣的人，甚至只是單純想探索更多可能性，新芽絕對是你值得一試的選擇！</p>
        `,
  },
  {
    name: "CARINA",
    position: "Customer Success",
    img: Carina2,
    photo: Carina,
    article: `
            <p>Hi Hi 我是 Customer Success Intern - Carina</p>
            <p>在新芽裡主要負責協助用戶解決在使用蛋糕時遇到的大大小小問題、蒐集用戶的使用者體驗回饋或建議並進一步紀錄，幫助蛋糕成為更貼近使用者需求與喜好的工具！</p>
            <p>在新芽不知不覺也快待了一年！</p>
            <p>從確定拿到新芽 offer 的當下到此刻對新芽的公司文化、環境、產品、同事們都沒有一刻感到失望過，且不僅如此，還讓我真正親身體會到為何新芽會是許多人心中的夢幻企業第一名！在新芽的工作氛圍非常友善、公司環境也非常舒適又賞心悅目（常常都會忘記自己是坐在辦公室還是咖啡廳 XD !? 幸福值 +++）、老闆及同事們除了專注在自己的工作外，也都非常樂於分享，非常能感受到大家都是以團隊能一起進步、能一起越來越好的方向前進的！且同事的樂於分享也不僅限於在工作上，大家也喜歡在群組創立興趣、話題類型的社團，讓大家除了是同事的關係外，也就像是一起玩的好朋友！在職場生活裡對我來說是非常難能可貴的！</p>
            <p>在 CS Team 的實習生活也非常的充實，因為新芽的 CS 有別於以往傳統的客服，而多了更像是「主動出擊」的行為，除了在用戶有問題時我們能給予完整且最貼近用戶的解答協助用戶排除問題，CS Team 的日常也會透過用戶的提問整理出已經被用戶詢問過的問題，定期加以撰寫對應的幫助中心文章、或加入在 Chatbot 中，在用戶提出完整問題前就已經可以因我們的「主動出擊」而找到最佳解、CS Team也會定期紀錄用戶給予的滿意度調查與建議，進一步和 PM Team 提出討論是否有可優化之處，完整地做到 Customer Success。</p>
            <p>若你也對 CS 的工作內容有興趣，又熱愛扁平且能提供你發揮想法的公司文化、也熱愛美美舒適的辦公環境，那麼勇敢地投出履歷吧！成為新芽大家庭的一份子，真的會有超出你意料之外的許多收穫哦！！！</p>
        `,
  },
  {
    name: "PHOEBE",
    position: "Product Management",
    img: Phoebe2,
    photo: Phoebe,
    article: `
            <p>Hi！我是 Phoebe :)</p>

            <p>首先，很開心可以加入新芽大家庭，擔任 SurveyCake PM Intern。對我來說，在新芽實習是一趟很有趣、很驚喜、讓人成長的旅程，會這麼說是因為除了可以接觸到很廣泛的工作內容外，也能夠擁有自主獨立執行的專案經驗，還能認識到許多厲害的神人！</p>
            
            <p>可以接觸的知識領域包含 SurveyCake B2B2C 的商業模式與定位、產品 QA 測試、使用者研究、設計規劃、競品功能分析、產品數據指標 Dashboard、流程執行的文件撰寫；在團隊互動上除了能與同期的實習生學習，也可以與設計師、前後端的開發者直接討論，還能和其他市場處單位，甚至是老闆一同開會討論，這些都是沒有預期到會發生的，但是令人感到很有挑戰、很有成就感的學習養分。</p>
            
            <p>一直沒有接觸過但對 PM 很有興趣的我來說，很幸運的在新芽實習計畫找到自己的職涯方向，也很謝謝 SurveyCake 工作夥伴的幫助與交流，才能夠在實習的路上收穫滿滿！歡迎對產品管理有興趣的夥伴一起加入新芽打拼 & 學習 ><</p>
        `,
  },
  {
    name: "FRANK",
    position: "Product Management",
    img: Frank2,
    photo: Frank,
    article: `
            <p>嗨，我是 BackStage 的 Product Management 實習生 Frank</p>
            <p>很開心可以加入新芽，在 Backstage 的產品開發團隊中，我的主要任務是進行測試來確保產品的穩定性，同時也會參與產品功能的設計，和設計師、開發者合作把一個個問題轉化為新的功能來滿足不同的需求，讓 Backstage 變得更好。</p>
            <p>在過程中，需要像一塊海綿一樣，不斷地吸收、學習，從如何把產品文件撰寫得更加清楚、如何增加溝通效率、甚至需要理解產品開發技術的基礎概念 ... 等，永遠有可以做得更好的地方。</p>
            <p>不論遇到什麼樣的困難，只要勇於發問、求助，新芽的大家都很樂意提供協助，很開心選擇加入這個友善又充滿挑戰的環境，和大家一起合作、交流、學習真的是一段難忘也難得的寶貴經驗。</p>
        `,
  },
  {
    name: "DANNY",
    position: "Product Management",
    img: Danny2,
    photo: Danny,
    article: `
    <p>Hello！我是第九屆的 SurveyCake Product Management Intern 歐陽，在這邊寫一些工作內容及成長，希望能讓大家更了解這個職位！</p>
    <p>我在新芽總共待了 8 個月的時間，每周排班 3~4 天 ，在這樣的基礎下，我的工作內容包括【功能規劃研究專案* 2】【產品專業版功能數據分析】【跨部門任務協作】【Spec 撰寫】【手動測試、會議記錄、Scrum 資料維運、跨部門報告等周期性任務】，是很充實的 8 個月！但除了正職交付的事情外，這邊也提供很大的彈性讓實習生爭取自己想做的事，我覺得很適合有明確學習目標的人 ~</p>
    <p>收穫的部分，除了能有機會做業界專案、一窺產品數據庫等我本來就很期待的事情外，也學習到跟工程端、設計端、市場端的溝通技巧；而在 SurveyCake 這樣的 SaaS 產品下，不知不覺也幫自己累積了一些軟體產品的知識，同時也因為產品正在快速成長的特性，很多時候也帶給我產品成長與商業面、技術面之間的關係與取捨的反思，我覺得是我自己原本沒有想到且很難能可貴的經驗！</p>
    <p>以上，新芽的環境很好及伙伴很友善相信應該很多人會寫所以這邊就不贅述，歡迎大家加入新芽這個大家庭 ^o^ ~</p>
            `,
  },
];



// WEBPACK FOOTER //
// ./src/models/Sprouters2022.js